import request from '@/utils/request.js'
import router from '@/router'

export default vm => {
  return {
    namespaced: true,
    state: {
      user: {},
      menu: {},
      companyName: ''
    },
    mutations: {
      user: (state, user) => {
        state.user = user
      },
      menu: (state, menu) => {
        state.menu = menu
      },
      companyName: (state, companyName) => {
        state.companyName = companyName
      }
    },
    actions: {
      getCur: (context, playload) => {
        request
          .get('/user/login/getCurInfo')
          .then(data => {
            context.commit('companyName', data.companyName)
            localStorage.setItem('curCompanyId', data.companyId)
          })
      },
      getOrg: (context, playload) => {
        request
          .get('/auth/findMy?bizType=org')
          .then(data => {
            context.commit('user', data)
          })
          .catch(msg => {
            context.rootGetters['alert'](msg)
          })
      },
      getMenu: (context, playload) => {
        request
          .get('/auth/findMy?bizType=menu')
          .then(data => {
            context.commit('menu', data[0])
          })
          .catch(msg => {
            context.rootGetters['alert'](msg)
          })
      },
      login: (context, playload) => {
        request
          .post('/user/login', playload)
          .then(data => {
            // 持久化token
            const token = data.token
            localStorage.setItem('token', token)
            localStorage.setItem('userName', data.userName)
            router.push('/Welcome')
          })
          .catch(msg => {
            context.rootGetters['alert'](msg)
          })
      },
      logout: context => {
        request
          .get('/user/login/logout')
          .then(data => {
            // 删除token
            localStorage.removeItem('token')
            localStorage.removeItem('curCompanyId')
            router.push('/')
          })
          .catch(msg => {
            context.rootGetters['alert'](msg)
          })
      },
      changeCompany: (context, playload) => {
        request
          .post('/user/login/changeCompany', playload)
          .then(data => {
            localStorage.setItem('curCompanyId', playload.companyId)
            // location.reload();
            router.push('/Welcome')
          })
          .catch(msg => {
            context.rootGetters['alert'](msg)
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/login.js